import { useAsyncExecutor2 } from "async-executor-hook";
import { addDays, format } from "date-fns";
import { useState } from "react";
import { parse, stringify } from "query-string";
import { map } from "rxjs";
import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import { getDateAttribute } from "../../common/searchParams.utils";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { AdminAppointmentConfigurationSearch } from "./AdminAppointmentConfigurationSearch";
import { AdminAppointmentConfigurationTable } from "./AdminAppointmentConfigurationTable";
import { useHistory } from "react-router-dom";
import {
  AdminAppointment,
  TimeslotsByDate,
} from "./AdminAppointment.interface";

const convertResponse = (resp: AdminAppointment) => {
  const timeslots_by_date = resp.timeslots_by_date.map(
    (timeslot: TimeslotsByDate) => {
      return {
        id: timeslot.timeslot_by_date_id,
        timeslotDate: timeslot.timeslot_date,
        timeslotStart: timeslot.timeslot_start,
        timeslotEnd: timeslot.timeslot_end,
        docksNum: timeslot.docks_num,
        dockCapacity: timeslot.dock_capacity,
      };
    }
  );
  return {
    timeslots_by_date,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};
interface IAdminAppointmentParams {
  date_start: Date;
  date_end: Date;
  page: number;
}

export const AdminAppointmentConfigurationResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: IAdminAppointmentParams) => {
      const date_start = getDateAttribute(params.date_start, new Date());
      const date_end = getDateAttribute(
        params.date_end,
        addDays(new Date(), 5)
      );

      return { ...params, date_start, date_end };
    })
  );

  const loadAppointmentConfiguration = useAsyncExecutor2(
    (params) => {
      return networkBackendRequest(`/timeslots-by-date/`, HTTP_METHODS.GET, {
        ...params,
      })
        .then((response) => response.json())
        .then(convertResponse);
    },

    {
      params$: params$.pipe(
        map((params) => {
          return {
            ...params,
            date_start: format(params.date_start, "yyyy-MM-dd"),
            date_end: format(params.date_end, "yyyy-MM-dd"),
            order: "descending",
            page: params.page ? params.page : 1,
            page_size: 6,
          };
        })
      ),
    }
  );

  const history = useHistory();
  const [showRangeConfirmation, updateShowRangeConfirmation] =
    useState<boolean>(false);

  const toggleRangeConfirmation = () => {
    updateShowRangeConfirmation(!showRangeConfirmation);
  };

  const [titleConfirmation, updateTitleConfirmation] = useState<string>("");
  const [messageConfirmation, updateMessageConfirmation] = useState<string>("");

  const onTitleConfirmationChange = (title: string) => {
    updateTitleConfirmation(title);
  };
  const onMessageConfirmationChange = (message: string) => {
    updateMessageConfirmation(message);
  };
  return (
    <div>
      <AdminAppointmentConfigurationSearch
        params$={params$}
        rangeConfirmation={toggleRangeConfirmation}
        onTitleConfirmationChange={onTitleConfirmationChange}
        onMessageConfirmationChange={onMessageConfirmationChange}
      />
      <AdminAppointmentConfigurationTable
        loadAppointmentConfiguration={loadAppointmentConfiguration}
        onTitleConfirmationChange={onTitleConfirmationChange}
        onMessageConfirmationChange={onMessageConfirmationChange}
        rangeConfirmation={toggleRangeConfirmation}
      />
      {showRangeConfirmation && (
        <ConfirmationModal
          toggleModal={() => {
            toggleRangeConfirmation();
          }}
          onAccept={() => {
            toggleRangeConfirmation();
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
          title={titleConfirmation}
          message={messageConfirmation}
        />
      )}
    </div>
  );
};
